module.exports = __webpack_public_path__ + "img/store.ed83ddda.svg";